// Centralised Siyanda Platinum dashboard IDs.

export const siyanda_platinum_dashboard_ids = {
  spud_shaft: '6b4571fd-9295-4eae-b4a7-7f2c633c04b5',
  // four_south: '08faeed9-da1d-4e8c-b67e-802c41614391',
  four_b_and_four_south: '9e103977-9207-4a4c-963a-e1e734a680c5',
  richard: '25d92ca5-358a-43b7-883f-c6592771b8fe'
};

export const siyanda_platinum_dashboard_ids_by_title = {
  'Spud Shaft': siyanda_platinum_dashboard_ids.spud_shaft,
  // '4 South': siyanda_platinum_dashboard_ids.four_south,
  'Declines': siyanda_platinum_dashboard_ids.four_b_and_four_south,
  'Richard': siyanda_platinum_dashboard_ids.richard
};

// Compatibility exports used by the dashboard view.
export const main_dashboard_id = siyanda_platinum_dashboard_ids.spud_shaft;
export const global_overview_dashboard_id = siyanda_platinum_dashboard_ids.spud_shaft;
export const global_daily_gm_dashboard_id = '2c29b02e-e057-4438-a1e4-5325f4872b83';
export const global_weekly_dashboard_id = 'c72daae0-66c0-4729-a448-a421064914a7';
export const global_monthly_dashboard_id = '83301f63-51a3-4635-aef8-ef3a2b599c39';
export const property_specific_dashboards = {
  'Spud Shaft': {
    daily: siyanda_platinum_dashboard_ids.spud_shaft,
    weekly: '4c249dc3-8b5c-417c-bbe3-aaba9411da33',
    monthly: '244dc26a-1351-4302-849d-18dca10069ea'
  },
  'Declines': {
    daily: siyanda_platinum_dashboard_ids.four_b_and_four_south,
    weekly: 'f3f0bda5-12d6-4447-9a10-7fe0925f6c60',
    monthly: 'b7ea8b76-90a4-4ed6-afd0-165df04a0986'
  },
  'Richard': {
    daily: siyanda_platinum_dashboard_ids.richard,
    weekly: 'e2702ce7-5ae1-4905-bafe-564b19d1e362',
    monthly: '03288383-f8e6-4669-b315-536f39524a67'
  }
};

export default {
  siyanda_platinum_dashboard_ids,
  siyanda_platinum_dashboard_ids_by_title,
  main_dashboard_id,
  global_overview_dashboard_id,
  global_daily_gm_dashboard_id,
  global_weekly_dashboard_id,
  global_monthly_dashboard_id,
  property_specific_dashboards
};
